/* パスワード */
import React, { useState, memo } from 'react';
import { FormControl, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import Paragraph from './Paragraph';
import { mask_string } from '../Const';

interface Props {
  id: string;
  fm_id?: number;
  label: string;
  need?: boolean;
  value: string;
  placeholder: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  message?: string;
  name?: string;
  help_msg?: string;
  disabled: boolean;
  maxlength?: number;
  handleBlur?: VoidFunction;
  handleFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  visible_type: string;
  readonly?: boolean;
}

const Password: React.FC<Props> = ({
  id,
  fm_id,
  label,
  need,
  value,
  placeholder,
  handleChange,
  message,
  name,
  help_msg,
  disabled,
  maxlength,
  handleBlur,
  handleFocus,
  visible_type,
  readonly,
}) => {
  // input type
  const [type, setType] = useState('password');
  // パスワードの表示
  const [is_visible, setIsVisible] = useState(false);

  /**
   * パスワードを表示
   */
  const handleChangeVisible = () => {
    const visible = !is_visible;

    if (visible) {
      setType(visible_type);
    } else {
      setType('password');
    }

    setIsVisible(visible);
  };

  /**
   * Changeイベント
   * @returns void
   */
  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const max_length = typeof maxlength !== 'undefined' ? maxlength : 0;
    if (is_visible && event.target.value.length > max_length) {
      return;
    }

    handleChange(event);
  };

  /**
   * max値の設定
   * @returns max値の文字列
   */
  const max = () => {
    let max = '';
    const max_length = typeof maxlength !== 'undefined' ? maxlength : 0;
    for (let i = 0; i < max_length; i++) {
      max += '9';
    }
    return max;
  };

  const returnTextFormJsx = () => {
    return (
      <>
        <div className="password row">
          <div className="col-12 col-sm-6 col-md-8">
            <FormControl
              id={id}
              data-fm_id={fm_id}
              type={type}
              value={value}
              onChange={handleChangeInput}
              placeholder={placeholder}
              name={name}
              disabled={disabled || readonly}
              onBlur={handleBlur}
              onFocus={handleFocus}
              maxLength={maxlength}
              min="0"
              max={max()}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-4">
            <label>
              <input type="checkbox" defaultChecked={is_visible} onChange={handleChangeVisible} />
              {label}を表示
            </label>
          </div>
        </div>
        <Messages help_msg={help_msg} valid_msg={message} />
      </>
    );
  };
  const returnLabelJsx = () => {
    // マスク文字列
    let masked_value = ''; // 初期化
    for (let i = 0; i < value.length; i++) {
      masked_value += mask_string;
    }

    return (
      <Row>
        <Col>
          <Paragraph label={masked_value} />
        </Col>
      </Row>
    );
  };
  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      content={disabled ? returnLabelJsx() : returnTextFormJsx()}
    />
  );
};

export default memo(Password);
